const styles = {
  wrapper: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 10px',
    marginLeft: 'auto',
  },
  nameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'right',
    justifyContent: 'space-evenly',
  },
  organization: {
    color: '#3D4A4D',
    fontSize: 12,
    marginBottom: 0,
    lineHeight: 1,
    fontWeight: 500,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    marginTop: 0,
  },
  displayName: {
    color: '#3D4A4D',
    fontSize: 10,
    marginBottom: 0,
    lineHeight: 1,
    fontWeight: 500,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    marginTop: 0,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/UserCard/styles.js